/**
 * Quick Analytics title row (scope badge beside title) + single subtitle from API visibility.
 */

const FALLBACK_VISIBILITY = {
  scope: 'personal_visibility',
  meetingsIncluded: 'Includes ended meetings you have access to.',
}

export default function QuickAnalyticsHeader({ visibility, className = '' }) {
  const v = {
    ...FALLBACK_VISIBILITY,
    ...(visibility && typeof visibility === 'object' ? visibility : {}),
  }
  const teamName = typeof v.teamName === 'string' && v.teamName.trim() ? v.teamName.trim() : ''
  const badge =
    v.scope === 'organization'
      ? { label: 'Organization', className: 'bg-indigo-50 text-indigo-800 border border-indigo-100' }
      : v.scope === 'team' && teamName
        ? {
            label: teamName.length > 28 ? `${teamName.slice(0, 27)}…` : teamName,
            className: 'bg-violet-50 text-violet-900 border border-violet-100 max-w-[min(100%,14rem)] truncate',
          }
        : { label: 'Personal', className: 'bg-emerald-50 text-emerald-800 border border-emerald-100' }

  const badgeTitle =
    v.scope === 'organization'
      ? 'All org meetings visible to you as org admin'
      : v.scope === 'team' && teamName
        ? `Team: ${teamName}`
        : 'Meetings you personally hosted, attended, or were invited to'

  return (
    <div className={`min-w-0 ${className}`}>
      <div className="flex flex-wrap items-center gap-x-2 sm:gap-3 gap-y-1.5">
        <h2 className="text-lg sm:text-xl font-semibold text-gray-900 tracking-tight">Quick Analytics</h2>
        <span
          className={`inline-flex shrink-0 items-center rounded-md px-2 py-0.5 text-[11px] sm:text-xs font-medium ${badge.className}`}
          title={badgeTitle}
        >
          {badge.label}
        </span>
      </div>
      <p className="mt-1.5 text-xs sm:text-sm text-gray-600 leading-snug [text-wrap:balance] sm:max-w-none">
        {v.meetingsIncluded}
      </p>
    </div>
  )
}
